import React, { useEffect, useState } from "react";
import { Button, Input } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { useEdges } from "@xyflow/react";


const DynamicFormList: React.FC<any> = ({ options, updateOptions }) => {
    const [formList, setFormList] = useState<{ name: string; value: string }[]>(options);


    useEffect(() => {
        setFormList(options);
    }, [options]);


    const handleChange = (index: number, field: "name" | "value", value: string) => {
        const updatedList = [...formList];
        updatedList[index][field] = value;
        setFormList(updatedList);
        updateOptions(updatedList);
    };

    const addField = () => {
        setFormList([...formList, { name: "", value: "" }]);
    };

    const removeField = (index: number) => {
        const updatedList = formList.filter((_, i) => i !== index);
        setFormList(updatedList);
        updateOptions(updatedList);
    };

    return (
        <div className="p-4 border rounded-lg max-w-lg mx-auto space-y-3">
            <h2 className="text-lg font-semibold">Options</h2>
            {formList.map((item, index) => (
                <div key={index} className="flex items-center space-x-2">
                    <Input
                        placeholder="Name"
                        value={item.name}
                        onChange={(e) => handleChange(index, "name", e.target.value)}
                        className="w-1/2"
                    />
                    <Input
                        placeholder="Value"
                        value={item.value}
                        onChange={(e) => handleChange(index, "value", e.target.value)}
                        className="w-1/2"
                    />
                    {formList.length > 1 && (
                        <Button
                            icon={<MinusCircleOutlined />}
                            onClick={() => removeField(index)}
                            danger
                        />
                    )}
                </div>
            ))}

            <Button type="dashed" onClick={addField} icon={<PlusOutlined />}>
                Add More
            </Button>
        </div>
    );
};

export default DynamicFormList;
